module.exports = __webpack_public_path__ + "files/d127196dc901845b569317eea86aec42.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/video.png
// module id = 583
// module chunks = 60